export default {
  FETCH_SESSION_REQUEST: 'FETCH_SESSION_REQUEST',
  FETCH_SESSION_ERROR: 'FETCH_SESSION_ERROR',
  FETCH_SESSION_SUCCESS: 'FETCH_SESSION_SUCCESS'
}
